import App from './App.vue'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { i18n } from './i18n'
import FloatingVue from 'floating-vue'
import router from './router'
import Notifications from '@kyvg/vue3-notification'
import FlagIcon from 'vue-flag-icon'
import { Skeletor } from 'vue-skeletor'
import './style.scss'
import 'vue-skeletor/dist/vue-skeletor.css'
import 'floating-vue/dist/style.css'

const app = createApp(App)
app.use(Notifications)
app.use(router)
app.use(FlagIcon)
app.use(FloatingVue)
app.use(i18n)
app.component(Skeletor.name, Skeletor)
app.use(createPinia())
app.mount('#app')
